<template>
  <transition 
  v-if="!disabled"
  v-bind:css="false"
  v-on:enter="expandAnimEnter"
  v-on:leave="expandAnimLeave">
    <slot></slot>
  </transition>
  <transition v-else>
    <slot></slot>
  </transition>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    expandAnimEnter: function (el, done) {
      Velocity(el, {translateY: 0}, { complete: done })
    },
    expandAnimLeave: function (el, done) {
      Velocity(el, {translateY: -128}, {complete: done})
    }
  }
}
</script>
